import React from "react";
import { RealtimeCandlestickChart } from "@/components/chart/RealtimeCandlestickChart";

export function HomePage() {
  return (
    <div className="mx-0 max-h-full w-full max-w-full p-1 sm:p-3">
      <RealtimeCandlestickChart />
    </div>
  );
}
